import { Component, Input, TemplateRef, ViewChild, ChangeDetectionStrategy, Output, EventEmitter, SimpleChanges, SimpleChange } from '@angular/core';
import { PopoverController, AlertController, ToastController, Events } from 'ionic-angular';
import { DatatableComponent } from '@swimlane/ngx-datatable'
import * as UserActions from '../../actions/user.actions';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import { Angular2Csv } from 'angular2-csv/Angular2-csv';
import { SharedModule } from './../../app/shared/shared.module';
import { Slug } from 'ng2-slugify';

@Component({
  selector: 'company-analysis-table',
  templateUrl: 'company-analysis-table.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompanyAnalysisTableComponent {

  @Output() goToCompany: EventEmitter<any> = new EventEmitter();
  @Input() companyAnalysis: any = { userColumns: [], defaultColumns: [], config: {} };
  @Input() pageLimit: number = 10;
  @Input() loading: boolean = false;
  @Input() hideFooter: boolean = false;
  @Input() title: string;
  @Input() showTopCount: boolean = false;
  @Input() filter: any;
  @Input() showSave: boolean = false;
  @Input() scrollbarV: boolean = false;
  @Input() rowHeight: string = 'auto';
  
  @ViewChild(DatatableComponent) table: DatatableComponent;
  @ViewChild('percentage0DecimalTemplate') percentage0DecimalTemplate: TemplateRef<any>;
  @ViewChild('percentageTemplate') percentageTemplate: TemplateRef<any>;
  @ViewChild('number1DecimalTemplate') number1DecimalTemplate: TemplateRef<any>;
  @ViewChild('numberTemplate') numberTemplate: TemplateRef<any>;
  @ViewChild('currencyTemplate') currencyTemplate: TemplateRef<any>;
  @ViewChild('billionTemplate') billionTemplate: TemplateRef<any>;
  @ViewChild('textTemplate') textTemplate: TemplateRef<any>;
  columnFilter: any = []
  allColumns: any = {
    ticker: 'FS Ticker',
    name: 'Name',
    region: 'Region',
    country: 'Country',
    sector: 'Sector',
    industry: 'Industry',
    sedol: 'Sedol',
    priceChange: 'Price Change',
    price: 'Price (LOC)',
    trailingEbitM: 'Trailing EBITM (%)',
    priceChangePercent: 'Price Change (%)',
    impliedEbitY3: 'Implied/Y3(e) (%)',
    impliedToTrailing: 'Implied To Trailing',
    impliedAsHistoricRange: 'Implied As Historic Range (%ile)',
    yearThreeOverTenYearMean: 'Y3(e)/10Yr Mean (%)',
    ebitMarginExpectation: 'Implied EBITM (%)',
    momentumTwelveMonth: 'Momentum 12m',
    momentumTwelveToNine: 'Momentum 12m/9m',
    yearThreeConsensusGrowth: 'Y3 Consensus Growth',
    iroceExpectation: 'Implied IROCE (%)',
    trailiingIroce: 'Trailing IROCE (%)',
    trailiingWci: 'Trailing WCI (%)',
    trailingFai: 'Trailing FAI (%)',
    ebitVolatility: 'EBITM Volatility',
    residualBalanceSheet: 'Res. Bal. Sheet (%)',
    overallFinancialGearing: 'Overall Financial Gearing',
    marketCap: 'Mkt. Cap. (B USD)',
    taxRate: 'Tax Rate',
    yearThree: 'Y3(e) EBITM (%)',
    forecastPerY1: 'PER(e) Y1',
    forecastPerY2: 'PER(e) Y2',
    forecastPerY3: 'PER(e) Y3',
    minorities: 'Minorities',
    liabilities: 'Liabilities',
    affiliates: 'Investments',
    yearOneConsensusGrowth: 'Y1 Consensus Growth',
    yearTwoConsensusGrowth: 'Y2 Consensus Growth',
    yearOneEbitm: 'Y1(e) EBITM (%)',
    yearTwoEbitm: 'Y2(e) EBITM (%)',
    currentNetDebt: 'Current Net Debt',
    tenYearHi: 'Ten Year EBITM High',
    tenYearLow: 'Ten Year EBITM Low',
    tenYearMean: 'Ten Year EBITM Mean'
  };
  columns: any = [];
  userColumns: any = [];
  sorts: any = [{
    "dir": "asc",
    "prop": "name"
  }];
  results: any = [];
  slug = new Slug('default');

  constructor(public popoverCtrl: PopoverController,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    public eventsCtrl: Events,
    private store: Store<fromRoot.State>) {
    this.columns = this.getColumns(this.columnFilter);
  }

  ngOnInit() {
    if (this.companyAnalysis && this.companyAnalysis.results) {
      this.results = this.companyAnalysis.results
    }
  }

  saveAsWatchlist($event) {

    let SaveAsWatchlistPopover = this.popoverCtrl.create('SaveAsWatchlistPage',
      { filter: this.filter, results: this.companyAnalysis.results });

    SaveAsWatchlistPopover.onDidDismiss(res => {
      if (res) {
      }
    });
    SaveAsWatchlistPopover.present({ ev: $event });


    // let confirm = this.alertCtrl.create({
    //   title: 'Save as watchlist',
    //   message: `Would  you like to save the stocks shown here, or the screening filters? `,
    //   buttons: [
    //     {
    //       text: 'Cancel',
    //       handler: () => {
    //         console.info('cancel clicked');
    //       }
    //     },
    //     {
    //       text: 'Stocks',
    //       handler: () => {
    //         this.newFilterNamePrompt().then(data => {
    //           if (data && data['filterName']) {
    //             console.log('filterName:', data['filterName']);
    //             let newFilter = JSON.parse(JSON.stringify(this.filter));
    //             newFilter.name = data['filterName'];
    //             newFilter.ref = this.slug.slugify(data['filterName']);
    //             let tickers = this.companyAnalysis.results.map(r => r.ticker);
    //             console.log('Saving stocks:', tickers);
    //             newFilter.tickers = tickers;
    //             newFilter.screens = {};
    //             newFilter.watchlist = true;
    //             this.saveNewFilter(newFilter);
    //           }
    //         })
    //       }
    //     },
    //     {
    //       text: 'Screening',
    //       handler: () => {
    //         this.newFilterNamePrompt().then(data => {
    //           if (data && data['filterName']) {
    //             console.log('filterName:', data['filterName']);
    //             let newFilter = JSON.parse(JSON.stringify(this.filter));
    //             newFilter.name = data['filterName'];
    //             newFilter.ref = this.slug.slugify(data['filterName']);
    //             newFilter.tickers = null;
    //             newFilter.watchlist = true;
    //             this.saveNewFilter(newFilter);
    //           }
    //         })
    //       }
    //     }
    //   ]
    // });
    // confirm.present();
  }

  saveNewFilter(filter) {
    let newFilter = filter;
    this.eventsCtrl.publish('createFilter', newFilter);
    this.showToast(`Added watchlist called ${newFilter.name}`);
  }

  newFilterNamePrompt() {
    return new Promise((resolve, reject) => {
      const alert = this.alertCtrl.create({
        title: 'Give it a name',
        inputs: [
          {
            name: 'filterName',
            placeholder: 'Watchlist name'
          }
        ],
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            handler: data => {
              console.log('Cancel clicked');
              resolve();
            }
          },
          {
            text: 'Create',
            handler: data => {
              console.log(data.filterName);
              resolve(data);
            }
          }
        ]
      });
      alert.present();
    });
  }

  goCompany($event, resource) {
    if ($event.type === 'click') {
      this.goToCompany.emit($event.row.ticker);
    }
  }

  onSort($event) {
    const sort = {};
    this.sorts = $event.sorts;
    $event.sorts.forEach(sortElement => {
      sort[sortElement.prop] = sortElement.dir == 'asc' ? 1 : -1
    });

    this.filter.config.sort = sort;
    this.store.dispatch(new UserActions.UpdateFilter({ filter: this.filter }));
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('ngOnChanges')
    if (!this.companyAnalysis || !this.filter) {
      return;
    }
    if (this.companyAnalysis.results) {
      this.results = this.companyAnalysis.results;
  }
    this.columnFilter = this.filter.userColumns || this.filter.defaultColumns;

    if (!this.columnFilter) return;
    this.columns = this.getColumns(this.columnFilter);
    if (this.filter.config.sort) {
      this.sorts = [];
      Object.keys(this.filter.config.sort).forEach(prop => {
        this.sorts.push({
          prop,
          dir: this.filter.config.sort[prop] == 1 ? 'asc' : 'desc'
        });
      });
    }
  }

  showColumnsPopover($event) {
    let columnsPopover = this.popoverCtrl.create('CompanyAnalysisColumnsPage',
      { columns: this.allColumns, userColumns: this.columnFilter });
    columnsPopover.onDidDismiss(res => {
      if (res) {
        if (res.reset) {
          delete this.filter.userColumns;
          this.store.dispatch(new UserActions.UpdateFilter({ filter: this.filter }));
        } else {
          this.filter.userColumns = res;
          this.store.dispatch(new UserActions.UpdateFilter({ filter: this.filter }));
        }
      }
    });
    columnsPopover.present({
      ev: $event
    });
  }

  outputCsv() {
    const data = this.companyAnalysis.results.map(row => {
      return this.columnFilter.reduce((a, b) => { a[b] = row[b]; return a }, {});
    });
    const headers = Object.keys(data[0]).map(id => this.allColumns[id]);

    new Angular2Csv(data, `Company Comparison [${this.companyAnalysis.name}] ${new Date().getTime()}`, { headers });
  }



  getColumns(columnFilter) {
    const columnConfigsOverrides = {
      ticker: {
        cellTemplate: this.textTemplate,
        width: 70
      },
      name: {
        cellTemplate: this.textTemplate,
        width: 160
      },
      region: {
        cellTemplate: this.textTemplate,
        width: 160
      },
      country: {
        cellTemplate: this.textTemplate,
        width: 160
      },
      sector: {
        cellTemplate: this.textTemplate,
        width: 160
      },
      industry: {
        cellTemplate: this.textTemplate,
        width: 160
      },
      sedol: {
        cellTemplate: this.textTemplate,
        width: 160
      },
      priceChange: {
        cellTemplate: this.number1DecimalTemplate
      },
      price: {
        cellTemplate: this.currencyTemplate
      },
      overallFinancialGearing: {
        cellTemplate: this.numberTemplate
      },
      marketCap: {
        cellTemplate: this.billionTemplate
      },
      marketCapB: {
        cellTemplate: this.numberTemplate
      },
      forecastPerY1: {
        cellTemplate: this.numberTemplate
      },
      forecastPerY2: {
        cellTemplate: this.numberTemplate
      },
      forecastPerY3: {
        cellTemplate: this.numberTemplate
      },
      taxRate: {
        cellTemplate: this.percentage0DecimalTemplate
      }
    };

    let columns = [];

    Object.keys(this.allColumns).forEach(columnId => {
      columns.push(Object.assign({
        prop: columnId,
        name: this.allColumns[columnId],
        cellTemplate: this.percentageTemplate,//default percentage
        width: 80 // default 80 wide
      }, columnConfigsOverrides[columnId]));
    })

    columns = columns.filter(item => columnFilter.indexOf(item.prop) !== -1)

    return columns;
  }
  showToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'bottom'
    });

    toast.onDidDismiss(() => {
    });

    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/components/company-analysis-table/company-analysis-table.ts